<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon :color="localSchedule.enableTakeASelfie ? 'primary' : 'grey lighten-2'" @click="editValue()">
          <v-icon>mdi-camera-front-variant</v-icon>
        </v-btn>
      </template>
      <span>Request participants to take a selfie</span>
    </v-tooltip>
    <v-dialog persistent v-model="scheduleSelfieDialog" max-width="500">
      <v-card>
        <v-card-text class="pt-2">
          <v-form ref="scheduleSelfieTextForm" @submit.prevent="saveScheduleVoteModal()" class="mx-4 my-2">
            <v-textarea
              v-model="selfieTitleModel"
              :label="$t('admin.activities.edit.selfieMessage.header')"
              autocomplete="off"
              outlined
              prepend-icon="mdi-view-headline"
            ></v-textarea>
            <v-textarea
              :label="$t('admin.activities.edit.selfieMessage.input')"
              autocomplete="off"
              name="votePopupUrlModel"
              prepend-icon="mdi-message-video"
              v-bind:placeholder="$t('live.activity.selfie.before.message')"
              v-model="selfieTextModel"
              outlined
              :hint="'This message will be shown to participant. Leave blank for default'"
              persistent-hint
            >
              <template v-slot:append-outer v-if="$vuetify.breakpoint.mdAndUp">
                <v-btn color="primary" elevation="0" fab tile type="submit" x-small>
                  <v-icon>mdi-open-in-app</v-icon>
                </v-btn>
                <v-btn @click="closeScheduleVoteModal()" class="ml-1" elevation="0" fab tile x-small>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-textarea>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ActivitiesEditSelfieModal",
  props: {
    schedule: Object,
  },
  data() {
    return {
      scheduleSelfieDialog: false,
      selfieTextModel: null,
      selfieTitleModel: null,
    };
  },
  methods: {
    closeScheduleVoteModal() {
      this.scheduleSelfieDialog = false;
      this.votePopupUrlModel = null;
      this.$refs.scheduleSelfieTextForm.resetValidation();
    },
    saveScheduleVoteModal() {
      this.localSchedule.selfieMessage =
        this.selfieTextModel && this.selfieTextModel.length > 0 ? this.selfieTextModel : null;
      this.localSchedule.selfieHeader =
        this.selfieTitleModel && this.selfieTitleModel.length > 0 ? this.selfieTitleModel : null;
      this.localSchedule.enableTakeASelfie = true;
      this.closeScheduleVoteModal();
    },
    editValue() {
      if (this.localSchedule.enableTakeASelfie === true) {
        this.localSchedule.enableTakeASelfie = false;
        this.localSchedule.selfieMessage = null;
        this.localSchedule.selfieHeader = null;
        return;
      }
      if (this.localSchedule.selfieMessage) {
        this.localSchedule.selfieMessage = null;
        this.localSchedule.selfieHeader = null;
      } else {
        this.scheduleSelfieDialog = true;

        this.selfieTextModel = this.$t("live.activity.selfie.before.message");
        this.selfieTitleModel = this.$t("live.activity.selfie.beforeRun.title");
      }
    },
  },
  computed: {
    localSchedule: {
      get() {
        return this.schedule;
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
};
</script>

<style scoped></style>
